<template>

    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <div class="form-group mb-0">

            </div>
        </form>
        <a-drawer title="" width="650" placement="right" @close="onClose" :visible="showDrawer">
                <h6 class="heading-small text-muted mb-4">Account Settings</h6>  
                <base-alert v-if="errors.length" type="danger">
                    <b>You have the following error(s):</b>
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                </base-alert>
                <form>
                    <a-tabs defaultActiveKey="1" type="card">
                      <a-tab-pane tab="Global" key="1">
                            <a-tabs defaultActiveKey="1" tab-position="left">
                              <a-tab-pane tab="Inventory Documents" key="1" class="mb-2 mr-2">
                                <base-input label="Costing Method" size="lg" required>
                                    <select class="form-control form-control-sm" input-classes="form-control" v-model="accountCredentials.documentCostingMethod" disabled>
                                        <option v-for="option in costingMethodOptions" v-bind:value="option.key" :key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                                <base-checkbox class="mb-3" v-model="accountCredentials.enableInventorySnapshot"
                                        >Enable Inventory Snapshot</base-checkbox>
                              </a-tab-pane>


                              <a-tab-pane tab="Currency" key="2" class="mb-2 mr-2">
                                <base-input label="Default Currency" size="lg" required>
                                    <select class="form-control form-control-sm" input-classes="form-control" v-model="accountCredentials.defaultCurrency">
                                        <option value="0" key="Currency0">PHP</option>
                                        <option v-for="option in currenciesOptions" v-bind:value="option.id" :key="'Currency'+option.id">
                                            {{ option.name }}
                                        </option>
                                    </select>
                                </base-input>
                              </a-tab-pane>

                              <a-tab-pane tab="User" key="3" class="mb-2 mr-2">
                                <base-checkbox class="mb-3" v-model="accountCredentials.userPasswordFormatStrict"
                                >Enable Password Format Strict</base-checkbox>
                                <div v-if="accountCredentials.userPasswordFormatStrict">
                                  <span class="mb-0 text-sm font-weight-bold text-gray">Password minimum length.</span><br>
                                  <small class="text-gray">Enforce a minimum length of characters</small><br>
                                  <div class="mb-2">
                                    <div class="form-group row mb-0">
                                      <div class="col-sm-5">
                                        <input size="sm" min="6" v-model="accountCredentials.minPasswordLength" max="128" type="number" class="form-control mt-1">
                                      </div>
                                      <label class="col-sm-5 pl-0 col-form-label">characters</label>
                                    </div>
                                    <small class="text-gray mb-2">Need to be between 6 and 128</small>
                                  </div>
                                  <div class="mb-2">
                                    <span class="mt-2 text-sm font-weight-bold text-gray">Password Strength</span><br>
                                    <base-checkbox v-model="accountCredentials.passwordReqOneUppercase" class="mt-1"><small>Require atleast one uppercase letter from the Latin alphabet (A-Z)</small></base-checkbox>
                                    <base-checkbox v-model="accountCredentials.passwordReqOneLowercase"><small>Require atleast one lowercase letter from the Latin alphabet (a-z)</small></base-checkbox>
                                    <base-checkbox v-model="accountCredentials.passwordReqOneNumber"><small>Require atleast one number</small></base-checkbox>
                                    <base-checkbox v-model="accountCredentials.passwordReqOneSpecialChar"><small>Require atleast one non-alphanumeric character (!@#$%^&*()_+-=[]{}|'")</small></base-checkbox>
                                  </div>
                                  <span class="mb-0 text-sm font-weight-bold text-gray">Other requirements</span>
                                  <base-checkbox v-model="accountCredentials.onPasswordExpiration" class="mt-1"><small>Turn on password expiration</small></base-checkbox>
                                  <select v-if="accountCredentials.onPasswordExpiration" class="form-control form-control-sm mb-1 mt-1 w-50" input-classes="form-control" v-model="accountCredentials.passExpDuration" :required="accountCredentials.onPasswordExpiration">
                                      <option v-for="option in passExpDurationOption" v-bind:value="option.key" :key="option.key">
                                          {{ option.value }}
                                      </option>
                                    </select>
                                  <base-checkbox v-model="accountCredentials.allowUserChangeOwnPassword" ><small>Allow users to change their own password</small></base-checkbox>
                                </div>
                              </a-tab-pane>

                              <a-tab-pane tab="Print Settings" key="4" class="mb-2 mr-2">
                                <p>Purchase to Payment module</p>
                                <base-input label="Increase font size" size="lg">
                                  <a-input-number style="width: 100%" :min="0" v-model='accountCredentials.printSettingsFontSizePTPM' placeholder='Increase font size by 0.1'/>
                                </base-input>
                                  <!-- <base-input label="Paper Size" size="lg" required>
                                    <select class="form-control form-control-sm" input-classes="form-control" v-model="accountCredentials.printSettingsPaperSizePTPM">
                                        <option v-for="option in paperSizeOptions" v-bind:value="option.value" :key="option.name">
                                            {{ option.name }}
                                        </option>
                                    </select>
                                </base-input> -->
                              </a-tab-pane>

                              <a-tab-pane tab="Business Type" key="5" class="mr-2">
                                <base-input label="Business Type" size="lg" required>
                                    <select class="form-control form-control-sm" input-classes="form-control" v-model="accountCredentials.accountBusinessType" checked disabled> 
                                        <option v-for="option in businessTypeOptions" v-bind:value="option.id" :key="option.id">
                                            {{ option.name }}
                                        </option>
                                    </select>
                                </base-input>
                              </a-tab-pane>
                              <a-tab-pane tab="System Alerts" key="6" class="mb-2 mr-2">
                                <base-input label="System Alerts / Reminders" size="lg">
                                    <base-checkbox class="mb-3" v-model="accountCredentials.zeroCostItems"
                                        >Zero Cost Items</base-checkbox>
                                    <base-checkbox class="mb-3" v-model="accountCredentials.zeroPriceItems"
                                        >Zero Price Items</base-checkbox>
                                    <base-checkbox class="mb-3" v-model="accountCredentials.retailPriceBelowLandedCost"
                                        >Retail Price Below Landed Cost</base-checkbox>
                                    <base-checkbox class="mb-3" v-model="accountCredentials.negativeOrZeroInventory"
                                        >Negative or Zero Inventory</base-checkbox>
                                    <base-checkbox class="mb-3" v-model="accountCredentials.lowStockItems"
                                        >Low Stock Items</base-checkbox>
                                    <base-checkbox class="mb-3" v-model="accountCredentials.overStockItems"
                                        >Over Stock Items</base-checkbox>
                                    <base-checkbox class="mb-3" v-model="accountCredentials.pendingDocuments"
                                        >Pending Document Assigned to Me</base-checkbox>
                                    <base-checkbox class="mb-3" v-model="accountCredentials.intransitDocuments"
                                        >Intransit Document Assigned to Me</base-checkbox>
                                </base-input>
                              </a-tab-pane>

                              <a-tab-pane tab="Site Pricing" key="7" class="mr-2">
                                  <p>Site Pricing</p>
                                  <base-checkbox class="mb-3" v-model="sitePricingEnabled" disabled>
                                     <p>Enable Site Pricing Feature</p>
                                  </base-checkbox>
                                  <p>Product can be enable or disable to specific sites. Product Price can be per site specific.</p>
                              </a-tab-pane>

                            </a-tabs>
                        </a-tab-pane>
                        <a-tab-pane tab="Payment Gateways" key="2">
                            <a-tabs defaultActiveKey="1" tab-position="left">
                              <a-tab-pane tab="Paymaya" key="1">
                                <base-input class= 'mb-0' alternative="" label="Key" v-model="accountCredentials.paymayaKey" type="password" input-classes="form-control"/>
                                <base-input class= 'mb-0' alternative="" label="Secret Key" v-model="accountCredentials.paymayaSecretKey" type="password" input-classes="form-control"/>
                              </a-tab-pane>
                              <a-tab-pane tab="Dragonpay" key="2">
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.dragonPayUserName" label="Username" type="text" input-classes="form-control"/>
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.dragonPayPassword" label="Password" type="password" input-classes="form-control"/>
                              </a-tab-pane>
                              <a-tab-pane tab="Ipay88" key="3">
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.ipay88MerchantCode" label="Merchant Code" type="text" input-classes="form-control"/>
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.ipay88MerchantKey" label="Merchant Key" type="text" input-classes="form-control"/>
                              </a-tab-pane>
                            </a-tabs>
                        </a-tab-pane>
                        <a-tab-pane tab="Logistics" key="3">
                            <a-tabs defaultActiveKey="1" tab-position="left">
                              <a-tab-pane tab="Mr.Speedy" key="1">
                                <base-input class= 'mb-0' alternative="" v-model="accountCredentials.mrSpeedyKey" label="Key" type="password" input-classes="form-control"/>
                              </a-tab-pane>
                            </a-tabs>
                        </a-tab-pane>

                    </a-tabs>
                    <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                        <button class="btn btn-success" @click.prevent="saveIntegCredentials">Save</button>
                        <button class="btn" @click.prevent="onClose">Cancel</button>
                    </div>
                </form>
        </a-drawer>
        <a-drawer title="" width="60%" placement="right" @close="onCloseTimeEntry" :visible="showTimeEntryDrawer">
        <h6 class="heading-small text-muted mb-4">Time Entry</h6>  
        <base-alert v-if="errors.length" type="danger">
          <b>You have the following error(s):</b>
          <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>
        <base-alert v-if="successMessage != null" type="success">
          <span class="alert-inner--text"> {{successMessage}}</span>
        </base-alert>
        <a-tabs v-model="activeKey" type="card" @change="tabChange">
          <a-tab-pane tab="List" key="1">
            <div class="card border-0">
              <div class="card-body border-0 pt-1">
                <form>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="filter-bar ui basic segment grid">
                        <div class="ui form">
                          <div class="inline field">
                            <h6 class="heading-small text-muted mb-2">Search</h6>
                            <div class="row">
                              <div class="col">
                                <base-input alternative="" label="Date">
                                  <br>
                                  <a-date-picker class="w-100" :defaultValue="moment()" v-model="businessDate" :format="dateFormat" @change="formatDate" />
                                </base-input>
                              </div>
                              <div class="col">
                                <base-input alternative="" label="Site" inputClasses="w-100">
                                  <a-select v-model="siteId" class="w-100">
                                    <a-select-option v-for="site in sites" :key="site.code" :value="site.id">
                                      {{ site.name }}</a-select-option>
                                  </a-select>
                                </base-input>
                              </div>
                              <div class="col">
                                <base-input alternative="" label="Time Entry Type">
                                  <a-select v-model="timeEntryTypeId" class="w-100" >
                                    <a-select-option key="0" value="0">All</a-select-option>
                                    <a-select-option v-for="entry_type in entryTypes" :key="entry_type.id" :value="entry_type.id">
                                      {{ entry_type.name }}</a-select-option>
                                  </a-select>
                                </base-input>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <button
                        class="btn btn-sm btn-primary float-right"
                        style="width: 15%"
                        @click.prevent="getEntryList"
                      >
                        Apply Filters
                      </button>
                    </div>
                  </div>

                  <hr class="mt-4 mb-3" />
                  <div class="row mb-1">
                    <div class="col-md-6">
                      <h3>Results</h3>
                    </div>
                  </div>
                  <div class="card shadow">
                    <div class="table-responsive">
                      <a-table
                        :columns="Columns"
                        :dataSource="entryList"
                        :loading="loading"
                        :rowKey="(record) => record.id"
                        :pagination="pagination"
                        bordered
                      >
                      <template slot="image" slot-scope="image">
                        <img v-if="image!=null" class="img-fluid img-thumbnail" :src="image" alt="" />
                      </template>
                      </a-table>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="Log" key="2">
            <div class="card border-0">
              <div class="card-body border-0 pt-1">
                <div class="row">
                  <div class="col-md-6">
                    <base-input label="Site">
                      <a-select
                          show-search
                          size="large"
                          style="width: 100%"
                          placeholder="Site"
                          optionFilterProp="children"
                          v-model="logSiteId">
                          <a-select-option v-for="site in sites" :key="site.id" :value="site.id">{{site.name}}</a-select-option>
                      </a-select>
                    </base-input>
                    <base-input label="Entry Type">
                      <a-select
                        show-search
                        size="large"
                        style="width: 100%"
                        placeholder="Entry Type"
                        optionFilterProp="children"
                        v-model="entryTypeId">
                        <a-select-option v-for="entry_type in entryTypes" :key="entry_type.id" :value="entry_type.id">{{entry_type.name}}</a-select-option>
                      </a-select>
                    </base-input>
                    <div v-if="timeEntryLogVia == 'TEB'">
                      <base-input label="Fingerprint Reader" class="mb-5">
                        <select name="readerSelect" id="enrollReaderSelect" class="form-control" v-model="selectedFingerprintReader">
                            <option value="">Select Fingerprint Reader</option>
                            <option v-for="option in FingerprintReaderOptions" :value="option">{{ option }}</option>
                        </select>
                      </base-input>
                      <div class="form-row justify-content-center mb-3">
                        <div class="col mb-3 mb-md-0 text-center" v-for="index in verifyFingerPrint">
                            <i class="fa fa-fingerprint text-green  fa-2xl"></i>
                        </div>
                        <div class="col mb-3 mb-md-0 text-center" v-for="finger_not_scan in (1 - verifyFingerPrint.length)">
                            <i class="fa fa-fingerprint fa-2xl"></i>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <base-input label="Username/Email" placeholder="Username/Email" v-model="email"></base-input>
                      <base-input label="Password" @keyup.enter="addTimeEntryViaSignIn" placeholder="Password" type="password"  v-model="password"></base-input>
                    </div>
                    <div class="text-center">
                      <button v-if="timeEntryLogVia == 'TEB'" class="btn btn-sm btn-warning my-4 " @click.prevent="verifyFinger" style="width: 50%;"
                          :disabled="loadingTimeEntry">
                          <a-spin v-if="loadingTimeEntry" :spinning="loadingTimeEntry" />
                          <div v-else>Time Entry</div>
                      </button>
                      <button v-if="timeEntryLogVia == 'TES'" class="btn btn-sm btn-warning my-4 "  @click.prevent="addTimeEntryViaSignIn" style="width: 50%;"
                          :disabled="loadingTimeEntry">
                          <a-spin v-if="loadingTimeEntry" :spinning="loadingTimeEntry" />
                          <div v-else>Time Entry</div>
                      </button>
                      </div>
                  </div>
                  <div class="col-md-6">
                    <div v-if="timeEntryLogVia == 'TES'">
                      <div class="web-camera-container" >
                        <a-spin v-if="isCameraOpen && isLoading" :spinning="isLoading" />
                        <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                          <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                          <video v-show="!isPhotoTaken" ref="camera" :width="450" :height="367.5" autoplay></video>
                          <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="450" :height="367.5"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
        
        <div class="fixed-bottom mr-3 mb-3">
          <button class="btn float-right" @click.prevent="onCloseTimeEntry">Back</button>
        </div>
        </a-drawer>

         <!-- <template slot="modal-header">
           ACCOUNT SETTINGS
         </template>
         <template slot="default" style="height: 100vh;">
           <br>
           <h3 class="heading-small text-muted"><span class="fa fa-info-circle text-blue"/> Please input your account credentials/keys for integrations below </h3>
           <br>
           <a-tabs defaultActiveKey="1" type="card">
                <a-tab-pane tab="Payment Gateways" key="1">
                    <a-tabs defaultActiveKey="1" tab-position="left">
                      <a-tab-pane tab="Paymaya" key="1">
                        <base-input class= 'mb-0' alternative="" label="Key" v-model="accountCredentials.paymayaKey" type="password" input-classes="form-control"/>
                      </a-tab-pane>
                      <a-tab-pane tab="Dragonpay" key="2">
                        <base-input class= 'mb-0' alternative="" v-model="accountCredentials.dragonPayUserName" label="Username" type="text" input-classes="form-control"/>
                        <base-input class= 'mb-0' alternative="" v-model="accountCredentials.dragonPayPassword" label="Password" type="password" input-classes="form-control"/>
                      </a-tab-pane>
                    </a-tabs>
                </a-tab-pane>
                <a-tab-pane tab="Logistics" key="2">
                    <a-tabs defaultActiveKey="1" tab-position="left">
                      <a-tab-pane tab="Mr.Speedy" key="1">
                        <base-input class= 'mb-0' alternative="" v-model="accountCredentials.mrSpeedyKey" label="Key" type="password" input-classes="form-control"/>
                      </a-tab-pane>
                    </a-tabs>
                </a-tab-pane>
            </a-tabs>
            <br><br><br><br>
         </template>
          <div slot="modal-footer" class="w-50">
            <b-button v-if="ownerAccount" variant="success" size="sm" class="float-right" @click="saveIntegCredentials"> Save </b-button>
        </div> -->

        <ul class="navbar-nav align-items-center d-none d-md-flex">
            <!-- <li class="release-redirect-list-item">
              <a class="release-redirect-link" href="/releases" target="_blank">New Update  <i class="fa fa-bell"></i></a>
            </li> -->
            <li id="user-profile-dropdown" data-testid="user-profile-dropdown" class="nav-item dropdown">
                <base-dropdown id="user-profile-base-dropdown" data-testid="user-profile-base-dropdown" class="nav-link pr-0 bg-white rounded" position="left">
                    <div id="user-profile" data-testid="user-profile" class="media align-items-center px-3 py-1" slot="title">
                      <span id="user-avatar" data-testid="user-avatar" class="avatar avatar-sm rounded-circle">
                        <img id="account-logo" data-testid="account-logo" :src="accountLogo" alt="logobarter"/>
                        </span>
                        <div id="account_info" data-testid="account-info" class="media-body ml-2 d-none d-lg-block">
                            <span class="mb-0 text-sm font-weight-bold text-gray" data-testid="account-user-name"><b data-testid="account-name">{{accountName}}</b> - <b data-testid="account-user-name">{{userName}}</b></span><br>
                            <small id="account-server-type" class="text-gray" data-testid="account-server-type" v-if="this.$parent.serverType == 'ho'">HO SERVER - {{branchName}} </small>
                            <small id="account-server-type" class="text-gray" data-testid="account-server-type" v-else>BRANCH SERVER </small>
                        </div>
                    </div>

                    <template v-if='developerMode != true'>
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">User</h6>
                        </div>
                        <div id="reminder-settings" v-b-modal.modal-reminder-settings class="dropdown-item" data-testid="reminder-settings">
                            <i id="reminder-settings-icon" class="ni ni-bell-55"></i>
                            <span id="reminder-settings-label">Reminder Settings</span>
                        </div>
                        <div id="change-password" v-if="restrictChangePassword" v-b-modal.modal-1 class="dropdown-item" data-testid="change-password">
                            <i id="change-password-icon" class="ni ni-lock-circle-open"></i>
                            <span id="change-password-label">Change Password</span>
                        </div>
                        <div id="time-entry" v-if="isEnableTimeEntry" @click.prevent="openTimeEntry" class="dropdown-item" data-testid="time-entry">
                            <i id="time-entry-icon" class="ni ni-lock-circle-open"></i>
                            <span id="time-entry-label" >Time Entry</span>
                        </div>
                        <div id="login-history" v-b-modal.modal-login-history class="dropdown-item" data-testid="login-history">
                            <i id="login-history-icon" class="fa fa-history"></i>
                            <span id="login-history-label">Login History</span>
                        </div>
                        <!-- <router-link to="/profile" class="dropdown-item">
                            <i class="ni ni-calendar-grid-58"></i>
                            <span>Activities</span>
                        </router-link> -->
                        <div class=" dropdown-header noti-title">
                            <h6 class="text-overflow m-0">Configurations</h6>
                        </div>
                        <div id="configuration" v-b-modal.modal-2 class="dropdown-item" data-testid="configuration">
                            <i id="configuration-icon" class="fa fa-wrench"></i>
                            <span id="configuration-label">Configuration</span>
                        </div>
                        <div id="account-settings" v-if="ownerAccount" class="dropdown-item" @click.prevent="openAccountSettings" data-testid="account-settings">
                            <i id="account-settings-icon" class="fa fa-cog"></i>
                            <span id="account-settings-label">Account Settings</span>
                        </div>
                        <div id="privacy-settings" v-b-modal.modal-4 class="dropdown-item" data-testid="privacy-settings">
                            <i id="privacy-settings-icon" class="fa fa-cogs"></i>
                            <span id="privacy-settings-label">Privacy Settings</span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div id="switch-branch" v-b-modal.modal-3 v-if="this.$parent.serverType == 'ho'" class="dropdown-item" @click="getSites" data-testid="switch-branch">
                            <i id="switch-branch-icon" class="fa fa-exchange-alt" data-testid="switch-branch-icon"></i>
                            <span id="switch-branch-label" data-testid="switch-branch-label">Switch Branch</span>
                        </div>
                        <div id="logout-user" class="dropdown-item" @click.prevent="logout" data-testid="logout-user">
                            <i id="logout-user-icon" class="ni ni-user-run" data-testid="logout-user-icon"></i>
                            <span id="logout-user-label" data-testid="logout-user-label">Logout</span>
                        </div>
                    </template>
                    <template v-else>
                        <div id="logout-developer" class="dropdown-item" data-testid="logout-developer">
                            <i id="logout-developer-icon" class="ni ni-user-run" data-testid="logout-developer-icon"></i>
                            <span id="logout-developer-button" @click.prevent="logout" data-testid="logout-developer-button">Logout</span>
                        </div>
                    </template>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>

<script>
  import HTTPRequest from '../controllers/httpRequest.js'
  import secureStorage from '../controllers/secureStorage.js'
  import { mapState, mapActions } from 'vuex'
  import axios from "axios";

  import moment from 'moment';
  import ValidateField from '../components/validateFormUtils'
  import { uploadToS3 } from '../utilities';
  // import '../directives/es6-shim.js'
  // import '../directives/websdk.client.bundle.min.js'
  // import Fingerprint from '../directives/fingerprint.sdk.min.js'

  var component_x, navigate;

  
  // let currentFormat = Fingerprint.SampleFormat.Intermediate;

  // let FingerprintSdkTest = (function () {
  //   function FingerprintSdkTest() {
  //       this.operationToRestart = null;
  //       this.acquisitionStarted = false;
  //       // instantiating the fingerprint sdk here
  //       this.sdk = new Fingerprint.WebApi;
  //       this.sdk.onDeviceConnected = function (e) {
  //         // Detects if the device is connected for which acquisition started
  //         component_x.showMessage("Scan Appropriate Finger on the Reader", "success");
  //       };
  //       this.sdk.onDeviceDisconnected = function (e) {
  //         // Detects if device gets disconnected - provides deviceUid of disconnected device
  //         component_x.showMessage("Device is Disconnected. Please Connect Back");
  //       };
  //       this.sdk.onCommunicationFailed = function (e) {
  //         // Detects if there is a failure in communicating with U.R.U web SDK
  //         // component_x.showMessage("Communication Failed. Please Reconnect Device")
  //       };
  //       this.sdk.onSamplesAcquired = function (s) {
  //         // Sample acquired event triggers this function
  //         component_x.storeSample(s);
  //       };
  //       this.sdk.onQualityReported = function (e) {
  //         // Quality of sample acquired - Function triggered on every sample acquired
  //         // document.getElementById("qualityInputBox").value = Fingerprint.QualityCode[(e.quality)];
  //       }
  //     }

  //     // this is were finger print capture takes place
  //     FingerprintSdkTest.prototype.startCapture = function () {
  //         if (this.acquisitionStarted) // Monitoring if already started capturing
  //             return;
  //         let _instance = this;
  //         component_x.showMessage("");
  //         this.operationToRestart = this.startCapture;
  //         this.sdk.startAcquisition(currentFormat, "").then(function () {
  //             component_x.acquisitionStarted = true;

  //             //Disabling start once started
  //             //disableEnableStartStop();

  //         }, function (error) {
  //             component_x.showMessage(error.message);
  //         });
  //     };
    
  //     FingerprintSdkTest.prototype.stopCapture = function () {
  //         if (!this.acquisitionStarted) //Monitor if already stopped capturing
  //             return;
  //         let _instance = this;
  //         component_x.showMessage("");
  //         this.sdk.stopAcquisition().then(function () {
  //             _instance.acquisitionStarted = false;
  //             //Disabling stop once stopped
  //             disableEnableStartStop();
  //         }, function (error) {
  //             component_x.showMessage(error.message);
  //         });
  //     };

  //     FingerprintSdkTest.prototype.getInfo = function () {
  //         let _instance = this;
  //         return this.sdk.enumerateDevices();
  //     };

  //     FingerprintSdkTest.prototype.getDeviceInfoWithID = function (uid) {
  //         let _instance = this;
  //         return  this.sdk.getDeviceInfo(uid);
  //     };
    
  //   return FingerprintSdkTest;
  // })();


  // class Reader{
  //   constructor(){
  //       this.reader = new FingerprintSdkTest();
  //       /**
  //         * @type {Hand}
  //         */
  //       this.currentHand = null;
  //   }

  //   displayReader(){
  //       let readers = this.reader.getInfo();  // grab available readers here
  //       readers.then(function(availableReaders){  // when promise is fulfilled
  //           if(availableReaders.length > 0){
  //                 for(let reader of availableReaders){
  //                   component_x.FingerprintReaderOptions.push(reader)
  //                 }
  //           }
  //           else{
  //             component_x.showMessage("Please Connect the Fingerprint Reader");
  //           }
  //       })
  //   }
  // }

  // class Hand{
  //     constructor(){
  //         this.id = 0;
  //         this.index_finger = [];
  //         this.middle_finger = [];
  //     }
  //     generateFullHand(){
  //         let id = this.id;
  //         let index_finger = this.index_finger;
  //         let middle_finger = this.middle_finger;
  //         return JSON.stringify({id, index_finger,middle_finger});
  //     }
  // }

  // let myReader = new Reader();

  export default {
  mounted: async function(){
    component_x = this;
    // bryan
    navigate = this.$router;
    if (this.developerMode == true){
      this.userName = secureStorage.getItem("developerEmail")
      this.branchName =  "Developer"
      this.accountName = "Developer"
    }

    //Get Account Logo
    // let logoSettings = await HTTPRequest.getRequest(this.endPoint + 'settings?code=account_logo', null)
    //   if (logoSettings.length > 0 && logoSettings[0]["value"] != null)
    //     this.accountLogo = logoSettings[0]["value"]
    await this.getAccountSettings()
    if(this.accountCredentials.onPasswordExpiration!=undefined && this.accountCredentials.onPasswordExpiration && this.userPasswordExpiration!=undefined){
      if(this.dateToday > new Date(this.userPasswordExpiration)){
        console.log("Expired")
        this.$confirm({
          title:"Password Expired",
          content: "your password has been expired. Please Click 'OK' to change password...",
          onOk(){
             component_x.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
          }
        })
      }
    }
  },
  computed: {
    ...mapState(['loggedIn', 'endPoint', 'validSites', 'selectedSite', 'checkCurrentSite']),
  },
    data() {
      return {
        sitePricingEnabled: false,
        siteProductFeaturesEnabled: false,
        accountLogo: secureStorage.getItem("account_logo"),
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
        userName: secureStorage.getItem("email"),
        userPasswordExpiration:secureStorage.getItem("passwordExpiration") || null,
        branchName: secureStorage.getItem("defaultSiteName"),
        accountName: secureStorage.getItem("accountName"),
        developerMode: secureStorage.getItem("developerMode"),
        configurationErrors: secureStorage.getItem("configurationErrorLogs"),
        showDrawer: false,
        accountCredentials: {},
        ownerAccount: secureStorage.getItem("isAccountOwner"),
        errors: [],
        costingMethodOptions: [
            {key: "FIFO", value: "FIFO"},
            {key: "LIFO", value: "LIFO"},
            {key: "AVERAGE", value: "Average"},
            {key: "BLENDED", value: "Blended Average"}
        ],
        passExpDurationOption: [
            {key: "1w", value: "One Week"},
            {key: "1m", value: "One Month"},
            {key: "2m", value: "Two Months"},
            {key: "3m", value: "Three Months"},
            {key: "6m", value: "Six Months"},
            {key: "1y", value: "1 Year"}
        ],
        currenciesOptions:[],
        businessTypeOptions:[],
        phpHasData:-1,
        restrictChangePassword:false,
        accountCredentialsCopy:{},
        isEnableTimeEntry:false,
        showTimeEntryDrawer:false,
        dateToday:new Date(),
        siteId:null,
        timeEntryTypeId:"0",
        entryTypes:[],
        sites:[],
        dateFormat: 'MM-DD-YYYY',
        businessDate: moment(),
        Columns:[
          {
            title: 'Time Entry Type',
            dataIndex: 'time_entry_type_name',
            width: '15%',
          },
          {
            title: 'Date Time Entry',
            dataIndex: 'date_time_entry',
            width: '20%',
            customRender: (value) => <div>{moment(value).format('YYYY-MM-DD HH:mm:ss A')}</div>
          },
          {
            title: 'Business Date',
            dataIndex: 'business_date',
            width: '15%',
            customRender: (value) => <div>{moment(value).format('YYYY-MM-DD')}</div>
          },
          {
            title: 'Site',
            dataIndex: 'site_name',
            width: '20%',
          },
          {
            title: 'Entry Origin',
            dataIndex: 'entry_origin',
            width: '15%',
          },
        ],
        entryList:[],
        loading:false,
        pagination: false,
        timeEntryLogVia:"TES",
        logSiteId:null,
        loadingTimeEntry:false,
        email:null,
        password:null,
        entryTypeId:null,
        successMessage:null,
        isCameraOpen: false,
        isPhotoTaken: false,
        isShotPhoto: false,
        isLoading: false,
        activeKey:"1",
        copyEntryList:[],
        // notExistingEntryTypes:[],
        selectedFingerprintReader:"",
        FingerprintReaderOptions:[],
        startedCapture:false,
        beginIdentificationStatus:false,
        verifyFingerPrint:[],
      };
    },
    watch: {
      selectedSite: function() {
          this.branchName = this.selectedSite
      },
      checkCurrentSite: function() {
        if(this.checkCurrentSite){
          this.branchName = secureStorage.getItem("defaultSiteName")
        }
      },
      accountCredentials:function(){
        if(this.accountCredentials.documentCostingMethod !== undefined){
          this.errors = []
        }
      },
      selectedFingerprintReader: function() {
        if(this.selectedFingerprintReader!=="" && !this.startedCapture){
          this.beginCapture()
        }
      }
    },
    methods: {
      moment,
      onClose(){
        this.accountCredentials.documentCostingMethod = undefined
        this.errors = []
        this.showDrawer = false;
      },
      onCloseTimeEntry(){
        this.showTimeEntryDrawer = false;
        this.sites = []
        this.entryTypes = []
        this.entryList = []
        this.businessDate = moment()
        this.siteId = secureStorage.getItem("SelectedSiteId") || null;
        this.timeEntryTypeId = "0"
        this.activeKey = "1"
        if(this.timeEntryLogVia == "TES" && this.isCameraOpen){
          this.isCameraOpen = false;
          this.isPhotoTaken = false;
          this.isShotPhoto = false;
          this.stopCameraStream();
        }
      },
      checkSettings(settings){
          let requiredFields;
          if(settings !==null){
              requiredFields = JSON.parse(settings.value)
              if(requiredFields["documentCostingMethod"] === undefined){
                this.errors.push("Costing Method is required")
              }
          }else{
                this.errors.push("Costing Method is required")
          }
      },
      async getAccountSettings(){
        var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
        try {
          this.accountCredentials = JSON.parse(credentials.value)
          this.accountCredentialsCopy = this.accountCredentials
        } catch (error) {}
        var categoryId = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories?code=TK-001', null, null)
        if(categoryId.length > 0){
          this.activeModules = await HTTPRequest.getRequest(this.endPoint + '/system_module_categories/' +  categoryId[0].id + '/enabled_modules', null, null)
          var response = await HTTPRequest.getRequest(this.endPoint + "/system_settings?module_name=tk",null);
          if (response.data[0] != undefined && this.activeModules.length > 0 ) {
            var settings = JSON.parse(response.data[0].settings_json);
            this.isEnableTimeEntry = settings.is_enabled_time_keep_in_rms || false
            this.timeEntryLogVia = settings.time_entry_log_via || false
            if(this.timeEntryLogVia == "TES"){
              this.Columns = [...this.Columns,{title: 'Image',dataIndex: 'image',width: '15%',key: "image",scopedSlots: { customRender: "image" },}]
            }
          } else {
            this.isEnableTimeEntry = false
          }
        }
        if (this.accountCredentials.allowUserChangeOwnPassword != undefined) {this.restrictChangePassword = this.accountCredentials.allowUserChangeOwnPassword}
      },
      async openAccountSettings(){
        this.showDrawer = true;
        var credentials = await HTTPRequest.getRequest(this.endPoint + 'settings/accountSettings?field_name=code' , null)
        this.checkSettings(credentials)
        this.getAccountBusinessType();
        this.getBusinessType();
        try {
          this.accountCredentials = JSON.parse(credentials.value)
          this.sitePricingEnabled = this.accountCredentials.sitePricingEnabled
        } catch (error) {}
        this.enableInventorySnapshot = this.accountCredentials.enableInventorySnapshot == undefined ? false : this.accountCredentials.enableInventorySnapshot
        this.accountCredentials.defaultCurrency==undefined ? this.accountCredentials.defaultCurrency = 0 : this.accountCredentials.defaultCurrency != 0 ? this.getDefaultCurrency() : ""
        this.getCurrencies()
      },
      async openTimeEntry(){
        await this.getValidSites()
        this.siteId = secureStorage.getItem("SelectedSiteId") || null;
        await this.getValidTimeEntryTypes()
        await this.getEntryList()
        // await this.generateNotExistEntryTypes()

        this.showTimeEntryDrawer = true;
        this.errors = []
        this.successMessage = null;
      },
      async saveIntegCredentials(){
        if(this.accountCredentials.onPasswordExpiration!=undefined && this.accountCredentials.onPasswordExpiration){
          if(this.accountCredentials.passExpDuration == null || this.accountCredentials.passExpDuration == undefined){
            this.$notification['error']({
              message: 'Error',
              description: "password Expiration Duration is a required field."
            });
            return "error"
          }
        }
        if(this.accountCredentials.documentCostingMethod !== undefined){
          var settingPayload = { setting: 
                               {code: "accountSettings", name: "Account Settings", value: JSON.stringify(this.accountCredentials), status: 'A'},
                         }
        var credentials = await HTTPRequest.postRequest(this.endPoint + 'settings', null, settingPayload)
        if(this.accountCredentials.onPasswordExpiration != undefined){
          if(this.accountCredentials.onPasswordExpiration || this.accountCredentialsCopy.onPasswordExpiration){
            var post_req = await HTTPRequest.postRequest(this.endPoint + 'settings/update_user_password_expiration', null, {pass_exp_setting:this.accountCredentials.onPasswordExpiration,duration:this.accountCredentials.passExpDuration})
          }
        }
        this.showDrawer = false;
        this.$notification['success']({
            message: 'Success',
            description: "You have succesfully updated account settings."
        });
        this.errors=[]
        }else{
          // bryan
          this.$notification['error']({
            message: 'Error',
            description: "Costing Method is a required field."
        });
        }
      },
      async getSites(){
        var sites = await HTTPRequest.getRequest(this.endPoint + '/users/' + secureStorage.getItem("userId")  + '/valid_sites', null, null)
        this.updateValidSites(sites)
      },
      async getCurrencies(){
        var currencies = await HTTPRequest.getRequest(this.endPoint + '/currencies?without_php='+true, null, null)
        if (currencies["error"] == undefined){
          this.currenciesOptions = currencies["data"]
        }else{
          this.$notification['error']({
            message: 'Failed',
            description: currencies["error"]
          });
        }
      },
      async getDefaultCurrency(){
        var default_currency = await HTTPRequest.getRequest(this.endPoint + 'currencies/'+this.accountCredentials.defaultCurrency, null)
        if(default_currency["error"] == undefined){
          (default_currency["status"]!="A") ? this.accountCredentials.defaultCurrency = 0 : ""
        }else{
          this.notifMessage = default_currency["error"].split(",");
        }
      },
      async getBusinessType(){
        var businessType = await HTTPRequest.getRequest(this.endPoint + '/system_business_types', null, null)
        if (businessType["error"] == undefined){
          this.businessTypeOptions = businessType
        }else{
          this.$notification['error']({
            message: 'Failed',
            description: businessType["error"]
          });
        }
      },
      async getAccountBusinessType(){
        var accountBusinessType = await HTTPRequest.getRequest(this.endPoint + '/users/get_account_business_type?user_id=' + secureStorage.getItem("userId"), null)
          this.accountCredentials.accountBusinessType = accountBusinessType.business_type_id
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      ...mapActions(['updateLoggedInStatus', 'updateValidSites']),

      logout(){
        // Clear the persisted Switch Branch location so a fresh login starts
        // with "All Locations".
        secureStorage.setItem("selectedLocationId", "");
        secureStorage.setItem("selectedLocationPath", "");
        if (this.developerMode == true){
          secureStorage.setItem("developerMode", false);
          secureStorage.setItem("userName", null);
          secureStorage.setItem("developerEmail", null);
          this.$router.push('/developer');

          var id = secureStorage.getItem("sessionId")
          axios({
            method: 'delete',
            url: this.endPoint + '/backend_sessions/' + id,
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
            },
          })
          .then(() => console.log("Session successfully deleted"))
          .catch(error => {
              console.log(error)
              console.log("Forcing session clear");
              this.clearExistingSession()
          })
          .finally(function () {
            component_x.updateLoggedInStatus(false);
            secureStorage.setItem("loggedIn", false)
            navigate.push('/developer');
          })

        }else{
        // Destroy Session
          var id = secureStorage.getItem("sessionId")
          axios({
            method: 'delete',
            url: this.endPoint + '/backend_sessions/' + id,
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress")
            },
          })
          .then(() => console.log("Session successfully deleted"))
          .catch(error => {
            console.log(error)
            console.log("Forcing session clear");
            this.clearExistingSession()
          })
          .finally(function () {
            component_x.updateLoggedInStatus(false);
            secureStorage.setItem("loggedIn", false)
            navigate.push('/');
          })
        }
      },
      async clearExistingSession(){
        const username = secureStorage.getItem("userCode")
        var post_request = await HTTPRequest.postRequest(this.endPoint + 'backend_sessions/delete_existing_session?email=' + username + '&account=' + this.accountName, null, null)
        console.log(post_request);
        if (post_request.status == true) {
          console.log("Session successfully cleared")
        } else {
          console.log("Error clearing existing session");
        }
      },
      formatDate() {
        if (this.businessDate != null) {
          this.businessDate = moment(this.businessDate).format('YYYY-MM-DD')
        } else {
          this.businessDate = ''
        }
      },
      async getValidSites(){
        this.sites = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_document_sites', null)
      },
      async getValidTimeEntryTypes(){
        this.entryTypes = await HTTPRequest.getRequest(this.endPoint + 'time_entry_types/get_valid_time_entry_types', null, null)
      },
      async getEntryList(){
        this.loading = true
        var entryList = await HTTPRequest.getRequest(this.endPoint + 'time_entries?user_id='+secureStorage.getItem("userId")+"&site_id="+this.siteId+"&business_date="+moment(this.businessDate).format('YYYY-MM-DD')+"&time_entry_type_id="+this.timeEntryTypeId, null, null)
        if(this.entryList.length == 0){
          this.copyEntryList = entryList.data
        }
        this. entryList = entryList.data
        this.loading = false
      },
      tabChange(activeKey){
        this.activeKey = activeKey
        if (activeKey == '1'){
          this.getEntryList();
        }
        if (activeKey =='2'){
          this.logSiteId = secureStorage.getItem("SelectedSiteId") || null;
          this.email = null
          this.password = null
          this.entryTypeId = null
          if (this.timeEntryLogVia == 'TES'){
            this.toggleCamera()
          }else if(this.timeEntryLogVia == 'TEB'){
            this.beginIdentification()
          }
        }
        this.errors = []
        this.successMessage = null
      },
      addTimeEntryViaSignIn: async function () {
        this.errors = []
        this.successMessage = null
        this.loadingTimeEntry = true
        if (!this.validationTimeENtryViaSignIn()) {
          var passwordResetPayload = { email: this.email, account_name: secureStorage.getItem("accountName") }
          var validateUser = await HTTPRequest.postRequest(this.endPoint + 'users/validate', null, passwordResetPayload)
          if (validateUser["error"] != undefined) {
            this.errors = ["Invalid login credentials. Please check your username or password."]
          } else {
            var bodyFormData = new FormData();
            bodyFormData.set('email', this.email);
            bodyFormData.append('password', this.password);
            bodyFormData.append('account_name', secureStorage.getItem("accountName"));
            bodyFormData.append('grant_type', 'password');
            var check_password = await HTTPRequest.postRequest(this.endPoint + "/time_entries/validate_password", null, {account_name: secureStorage.getItem("accountName"), email: this.email, password: this.password })
            if (check_password["error"] == undefined) {
              let ip_params = ""
              await axios({
                method: 'get',
                url: '//jsonip.com',
              })
                .then(function (response) {
                  if (response.data != null) {
                    // console.log(response.data.ip)
                    ip_params = response.data.ip
                  }
                })
                .catch(function () {
                  console.log("Network Error on IPIFY");
                });
              secureStorage.setItem("SelectedSiteId", this.logSiteId)
              if (component_x.errors.length==0){
                var payload = {
                  time_entry:{
                    site_id:this.logSiteId,
                    user_id: validateUser["success"][0]["id"],
                    business_date:moment().format("YYYY-MM-DD"),
                    time_entry_type_id:this.entryTypeId,
                    date_time_entry:moment(),
                    entry_origin:"browser",
                    ip_address:ip_params
                  }
                }
                var createTimeEntry = await HTTPRequest.postRequest(component_x.endPoint + 'time_entries', null, payload)
                if (createTimeEntry["error"] == undefined) {
                  if(this.isCameraOpen && !this.isLoading){
                    var image_url = await this.takePhoto()
                    if(image_url!=null){
                      var modulePayload = {time_entry: {image: image_url} }
                      await HTTPRequest.putRequest(component_x.endPoint + 'time_entries/'+ createTimeEntry.id, null, modulePayload)
                    }
                  }
                  this.successMessage = createTimeEntry["success_message"]
                  this.email = null;
                  this.password = null;
                  this.entryTypeId = null;
                } else {
                  this.errors = [createTimeEntry["error"]]
                }
              }
            } else {
              this.errors = [check_password["error"]]
            }
          }
        }
        this.loadingTimeEntry = false
      },
      validationTimeENtryViaSignIn(){
        this.errors.push(ValidateField.required('Site', this.logSiteId));
        this.errors.push(ValidateField.required('Entry Type', this.entryTypeId));
        this.errors.push(ValidateField.required('Email', this.email));
        this.errors.push(ValidateField.required('Password', this.password));
        this.errors = this._.compact(this.errors);
        return this.errors.length;
      },
      toggleCamera() {
        if(!this.isCameraOpen) {
          this.isCameraOpen = true;
          this.createCameraElement();
        }
      },
      createCameraElement() {
        this.isLoading = true;
        
        const constraints = (window.constraints = {
          audio: false,
          video: true
        });
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(stream => {
            this.isLoading = false;
            this.$refs.camera.srcObject = stream;
          })
          .catch(error => {
            this.isLoading = false;
            alert("May the browser didn't support or there is some errors.");
          });
      },
      stopCameraStream() {
        let tracks = this.$refs.camera.srcObject.getTracks();

        tracks.forEach(track => {
          track.stop();
        });
      },
      async takePhoto() {
        if(!this.isPhotoTaken) {
          this.isShotPhoto = true;
          this.isPhotoTaken = true;

          const FLASH_TIMEOUT = 2500;

          setTimeout(() => {
            this.isShotPhoto = false;
            this.isPhotoTaken = false;
          }, FLASH_TIMEOUT);
        }
        const context = this.$refs.canvas.getContext('2d');
        context.drawImage(this.$refs.camera, 0, 0, 450, 367.5);
        const dataUrl = this.$refs.canvas.toDataURL("image/jpeg").replace("image/jpeg", "image/octet-stream");
        let uniquePictureName = this.generateCapturePhotoName();
        let capturedPhotoFile = this.dataURLtoFile(dataUrl, uniquePictureName+'.jpg')
        const fileResponse = await uploadToS3(capturedPhotoFile, 'time_keep');
        if (fileResponse.path) {
          return fileResponse.path
        } else {
          return null
        }
      },
      generateCapturePhotoName(){
        return  Math.random().toString(36).substring(2, 15)
      },
      dataURLtoFile(dataURL, filename) {
        let arr = dataURL.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type: mime});
      },
      // generateNotExistEntryTypes(){
      //   this.notExistingEntryTypes = []
      //   this.entryTypes.forEach(function(item){
      //     var index = component_x.copyEntryList.findIndex(x=> x.time_entry_type_id == item.id)
      //     if (index <=-1){
      //       component_x.notExistingEntryTypes.push(item)
      //     }
      //   });
      // },
      async beginIdentification(){
        if(!this.beginIdentificationStatus){
            await myReader.displayReader();
            // await this.beginCapture()
            this.beginIdentificationStatus = true;
        }
      },
      showMessage(message, message_type="error"){
        if (message_type=="error" && message!=null && message!=undefined && message!=""){
          this.errors = message.split(",")
        }else{
          this.errors = []
        }
      },
      beginCapture(){
        if(!this.readyForIdentify()){
          return;
        }
        myReader.currentHand = new Hand();
        myReader.reader.startCapture();
        this.startedCapture = true
      },
      readyForIdentify(){
        return (this.selectedFingerprintReader !== "");
      },
      clearCapture(){
        this.clearHand();
        this.startedCapture = false
        this.verifyFingerPrint = []
      },
      clearHand(){
        myReader.currentHand = null;
      },
      stopCapture(){
        myReader.reader.stopCapture();
      },
      showSampleCaptured(s){
        if (this.verifyFingerPrint.length < 1){
          this.verifyFingerPrint.push(s[0].Data)
        }
      },
      storeSample(sample){
        let samples = JSON.parse(sample.samples);
        this.showSampleCaptured(samples);
        return;
      },
      validationVerifyFinger(){
        this.errors.push(ValidateField.required('Site', this.logSiteId));
        this.errors.push(ValidateField.required('Entry Type', this.entryTypeId));
        this.errors.push(ValidateField.required('Fingerprint Reader',this.selectedFingerprintReader))
        this.errors.push(ValidateField.requiredOne('Scanned Finger',this.verifyFingerPrint))
        this.errors = this._.compact(this.errors);
        return this.errors.length;
      },
      async verifyFinger(){
        this.errors = []
        if (!this.validationVerifyFinger()){
          var enrolled_fingers = await HTTPRequest.getRequest(this.endPoint + 'users/get_fingers?user_id='+ secureStorage.getItem("userId"), null,null)
          var fingers = JSON.stringify({pre_enrolled_finger_data:this.verifyFingerPrint[0],enrolled_index_finger_data:enrolled_fingers["index_finger"],enrolled_middle_finger_data:enrolled_fingers["middle_finger"]})
          var response =  await HTTPRequest.postRequest(this.endPoint + 'users/sample_verify_finger', null,{finger:fingers})
          if (response["status"] == "match"){
            let ip_params = ""
            await axios({
              method: 'get',
              url: '//jsonip.com',
            }).then(function (response) {
                if (response.data != null) {
                  // console.log(response.data.ip)
                  ip_params = response.data.ip
                }
            })
            .catch(function () {
              component_x.errors = ["Network Error on jsonip"];
            });
            secureStorage.setItem("SelectedSiteId", this.logSiteId)
            if (component_x.errors.length==0){
              var payload = {
                time_entry:{
                  site_id:this.logSiteId,
                  user_id: secureStorage.getItem("userId"),
                  business_date:moment().format("YYYY-MM-DD"),
                  time_entry_type_id:this.entryTypeId,
                  date_time_entry:moment(),
                  entry_origin:"browser",
                  ip_address:ip_params
                }
              }
              var createTimeEntry = await HTTPRequest.postRequest(component_x.endPoint + 'time_entries', null, payload)
              if (createTimeEntry["error"] == undefined) {
                this.successMessage = createTimeEntry["success_message"]
                this.email = null;
                this.password = null;
                this.entryTypeId = null;
                this.clearCapture()
              } else {
                this.errors = [createTimeEntry["error"]]
                this.clearCapture()
              }
            }
          }else{
            this.clearCapture()
            this.errors = ["Fingerprint is not match. please rescan finger"]
          }
        }
      }
    }
  };
</script>

<style>
.release-redirect-list-item{
  background-color: #e63946;
  border: 1px solid white;
  border-radius: 5px;
  font-size: 16px !important;
  font-weight: 500;
  margin-right: 20px;
  padding: 5px 10px;
  transition: all .1s;
}
.release-redirect-list-item a {
  color: white;
}
.release-redirect-list-item:hover{
  transform: scale(1.01);
  cursor: pointer;
}
.web-camera-container {
  margin-bottom: 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 500px;
}

.web-camera-container .camera-box .camera-shutter {
  opacity: 0;
  width: 450px;
  height: 337.5px;
  background-color: #fff;
  position: absolute;
}

</style>
